import { useRef, useState } from 'react'

import { Box, Button, MediumIcon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
export const ActionInput: React.FC<{
  autofocus?: boolean
  onSubmit: () => Promise<unknown> | unknown
  layout?: 'compact' | 'big'
  onChange: (text: string) => void
  value: string
  disabled?: boolean
  refocus?: boolean
  icon?: MediumIcon
  placeholder?: string
  onCancel?: () => void
}> = ({
  autofocus,
  placeholder,
  layout = 'compact',
  onSubmit,
  disabled,
  onChange,
  onCancel,
  refocus,
  value,
  icon = 'check',
}) => {
  const ref = useRef<HTMLElement>(null)
  const inputRef = useRef<HTMLTextAreaElement>(null)

  const [focused, setFocused] = useState(false)

  useUnsafeEffect(() => {
    if (autofocus) {
      focusInput()
    }
  }, [autofocus])

  const focusInput = () => {
    setFocused(true)
    const input = inputRef.current
    if (!input) return

    input.setSelectionRange(input.value.length, input.value.length)
    setTimeout(() => inputRef.current?.focus(), 100)
  }

  const scrollToInput = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

  const addItem = async () => {
    const previouslyFocused = focused
    await onSubmit()
    if (refocus && previouslyFocused) {
      setTimeout(focusInput, 10)
      setTimeout(scrollToInput, 250)
    }
  }

  const isEmpty = !value || value === ''

  // LOL this is an incredibly dirty cheat to get the textarea to auto-grow.
  // And it works! 🙃
  useUnsafeEffect(() => {
    if (!inputRef.current) return
    inputRef.current.style.height = '1px'
    inputRef.current.style.height = `${inputRef.current.scrollHeight}px`
  })

  return (
    <Box gap="s32" ref={ref}>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          addItem()
        }}
      >
        <Box flexDirection={layout === 'compact' ? 'row' : 'column'} gap="s24">
          <textarea
            autoFocus={autofocus}
            className={classNames('ActionInput_textarea', {
              ['ActionInput_unfocusedTextarea']: !focused,
            })}
            rows={1}
            ref={inputRef}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            onChange={(event) => {
              scrollToInput()
              onChange(event.target.value)
            }}
            onKeyDown={(event) => {
              if (event.key === 'Escape') {
                onCancel?.()
              }
            }}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
          >
            {value}
          </textarea>
          {!isEmpty && (
            <Box flexDirection="row" justifyContent="flexEnd" gap="s4">
              <Button
                disabled={disabled || isEmpty}
                iconName={icon}
                submit
                title={i18n.t('performance_process.agreements.action_button.save')}
              >
                {i18n.t('performance_process.agreements.action_button.save')}
              </Button>
            </Box>
          )}
        </Box>
      </form>
    </Box>
  )
}
